module.exports = __webpack_public_path__ + "img/MO.c93b7e41.svg";